import headerImage from "../../assets/oroPrestige/oroprestige-header.png";
import oroPuroMani from "../../assets/lingotti/0060 - Still life Care is gold-Modifica.webp";
import lingotti from "../../assets/oroPrestige/Lingotti_DX1.png";
import logo from '../../assets/oroPrestige/logo-trasp.webp';
import regalo from "../../assets/lingotti/0055 - Still life Care is gold-Modifica.webp";
import { ScrollParallax } from 'react-just-parallax';
import GoogleMaps from '../../components/GoogleMapsOP';
import { Wrapper } from "@googlemaps/react-wrapper";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import Form from '../../components/Form';
import { oroPrestigeFormFields } from "../../utils/formFields";
import { schemaOroPrestige } from "../../components/formComponent/formSchema";
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Helmet } from 'react-helmet';
import AOS from "aos";
import "aos/dist/aos.css";



function GioiellerieB2C() {
    const [gioiellerie, setGioiellerie] = useState([]);
    const [width, setWidth] = useState(window.innerWidth);
    const videoRef = useRef(null);
    const googleMaps = 'AIzaSyCZyoDZ5eFh61i2vM3zyDXUI3WVp3J4E9Y'
    var ogImage = 'https://www.careisgold.it/static/media/silhouette-…2023-11-27-05-37-25-utc.fff1423b79bacba527a2.webp';

    // togliere aos transition per mini-screen
    function initAOS() {
        AOS.init({
            disable: window.innerWidth <= 320 && window.innerHeight <= 256
        });
    }
    initAOS();
    window.addEventListener("resize", () => {
        AOS.refreshHard();
    });

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (videoRef.current) {
                        if (entry.isIntersecting && !document.hidden) {
                            videoRef.current.muted = true;
                            videoRef.current.play().catch((error) => {
                                // Handle the error
                                console.log('Video play failed:', error);
                            });
                        } else {
                            videoRef.current.pause();
                        }
                    }
                });
            },
            {
                threshold: 0.5, // Adjust this threshold as needed
            }
        );

        if (videoRef.current) {
            observer.observe(videoRef.current);
        }

        const handleVisibilityChange = () => {
            if (videoRef.current) {
                if (document.hidden) {
                    videoRef.current.pause();
                } else if (videoRef.current.getBoundingClientRect().top < window.innerHeight) {
                    videoRef.current.muted = true;
                    videoRef.current.play().catch((error) => {
                        // Handle the error
                        console.log('Video play failed:', error);
                    });
                }
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            if (videoRef.current) {
                observer.unobserve(videoRef.current);
            }
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    // const map = useRef(null);
    // const contatti = useRef(null);
    // const handleClickMap = () => {
    //     map.current?.scrollIntoView({ behavior: 'smooth' });
    // };
    // const handleClickContatti = () => {
    //     contatti.current?.scrollIntoView({ behavior: 'smooth' });
    // };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.post(`https://crm.careholding.it/ws/Call/?Cat=Gioiellerie&met=GetListaGioiellerieApertePublic&np=0`);
                setGioiellerie(res.data);
            } catch (err) {
                console.log(err);
            }
        };
        fetchData();
    }, []);

    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.2,
        rootMargin: '500px',
        passive: true,
    });

    const submitMapper = ({ data, landingName, idOrigin }) => ({
        NomeModulo: landingName,
        Provenienza: idOrigin,
        Dati: [
            { Key: "NomeCognome", Value: data.nomeCognome || "" },
            { Key: "Telefono", Value: data.telefono || "" },
            { Key: "Email", Value: data.email || "" },
            { Key: "Indirizzo", Value: data.indirizzo || "" },
            { Key: "Messaggio", Value: data.messaggio || "" },
        ],
    });

    const scrollToSection = (id) => {
        const lenis = window.lenis;

        if (lenis) {
            lenis.scrollTo(id, {
                duration: 1.2,
                offset: 0,
            });
        } else {
            document.querySelector(id)?.scrollIntoView({
                behavior: 'smooth',
            });
        }
    };

    const isMobile = window.innerWidth <= 640;


    return (
        <>
            <Helmet>
                <title>Oro Prestige: Lingotti d'Oro da Investimento nelle Gioiellerie | Careisgold</title>
                <meta name="description" content="Scopri Oro Prestige by Careisgold: il brand dedicato alle gioiellerie. Illumina la tua professione con i lingotti d'oro da investimento. Formazione e servizio chiavi in mano." />
                <meta name="keywords" content="Oro Prestige, lingotti oro, investimento oro, gioiellerie, Careisgold" />
                <meta property="og:title" content="Oro Prestige: Lingotti d'Oro da Investimento nelle Gioiellerie | Careisgold" />
                <meta property="og:description" content="Scopri Oro Prestige by Careisgold: il brand dedicato alle gioiellerie. Illumina la tua professione con i lingotti d'oro da investimento. Formazione e servizio chiavi in mano." />
                <meta property="og:image" content={ogImage} />
                <meta property="og:url" content="https://www.careisgold.it/oro-prestige/" />
                <meta property="og:type" content="page" />
                <link rel="canonical" href="https://www.careisgold.it/oro-prestige/" />
                <script type="application/ld+json">
                    {`
                    {
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "Careisgold SpA",
                    "url": "https://www.careisgold.it/oro-prestige/",
                    "logo": "https://www.careisgold.it/${logo}",
                    "description": "Scopri Oro Prestige by Careisgold: il brand dedicato alle gioiellerie. Illumina la tua professione con i lingotti d'oro da investimento. Formazione e servizio chiavi in mano.",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Via Monte Baldo 14/D",
                        "addressLocality": "Villafranca di Verona",
                        "addressRegion": "Veneto",
                        "postalCode": "37069",
                        "addressCountry": "IT"
                    },
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "+39 045 8213155",
                        "contactType": "Customer Service"
                    },
                    "sameAs": [
                        "https://www.facebook.com/careisgoldspa",
                        "https://www.instagram.com/careisgoldspa",
                        "https://www.linkedin.com/company/careisgold-spa"
                    ]
                    }
                `}
                </script>
            </Helmet>

            {/**careisgold porta oro puro - first section */}
            <div className='relative z-20 h-lvh overflow-hidden mini-screen:h-[850px] '>
                
                <ScrollParallax enableOnTouchDevice={true} isAbsolutelyPositioned={true} lerpEase="0.05">
                    <img src={headerImage} alt='background'
                        className={`absolute top-10 left-0 object-cover w-full h-[105vh] ${isMobile ? 'hidden' : 'block'}`}  style={{ transform: 'scale(1.2)' }}/>
                </ScrollParallax>
                
                
                <div className={`${isMobile ? 'flex flex-col relative justify-end' : 'absolute top-0 left-0 justify-center'} w-full h-full flex items-center`}> {/**bg-black bg-opacity-50 */}

                    <div className={`flex justify-start text-center md:text-start ps-15 mx-5 md:ml-[5%] ${isMobile ? 'absolute top-40' : 'relative'}`}>
                        <div className={`lg:w-[60%]`}>
                            <h1 className={`lg:text-5xl md:text-4xl text-3xl text-white font-semibold drop-shadow-lg text-balance mini-screen:text-xl`}
                                data-aos="fade-up" data-aos-duration="1000">Con Careisgold puoi comprare lingotti in oro da investimento in gioielleria</h1>
                            <p className={`text-xl mt-4 mb-10 text-white drop-shadow-lg text-balance mini-screen:text-base`}
                                data-aos="fade-up" data-aos-duration="1000">Careisgold porta l'Oro puro in boutique: scopri come iniziare a
                                costruire la tua riserva aurea nella tua gioielleria di fiducia.</p>

                            <div className='flex md:flex-row flex-col gap-5'>
                                <button
                                    onClick={() => scrollToSection('#second-section')}
                                    className="progress-button-light border-slate-50 text-slate-50 px-8 py-2 uppercase border text-center transition duration-300 ease-in-out hidden sm:flex"
                                >
                                    Scopri di più
                                </button>

                                <button
                                    onClick={() => scrollToSection('#mappa-gioiellerie')}
                                    className="progress-button-light border-slate-50 text-slate-50 px-8 py-2 uppercase border text-center transition duration-300 ease-in-out hidden sm:flex"
                                >
                                    Trova la gioielleria più vicina
                                </button>
                            </div>
                        </div>
                    </div>
                    <img src={headerImage} alt='background' className={`h-[450px] w-full object-cover object-[70%] -mt-20 ${isMobile ? 'block' : 'hidden'}`}/>
                </div>
            </div>


            {/**oro puro firmato careisgold - second section */}
            <section id='second-section'>
                <div className='mx-auto'>
                    <div className={`'h-fit mini-screen:h-[750px] flex justify-center items-center`}>
                        <div className={`'h-fit py-20 mini-screen:h-full w-full sm:w-3/4 md:bg-black bg-white 
                        flex justify-center items-center p-4 z-20`}>
                            <div className='text-left w-full sm:max-w-md lg:max-w-lg xl:max-w-xl mx-auto'>
                                <div className={` text-2xl md:text-3xl xl:text-6xl font-semibold mb-5 text-black md:text-white text-center md:text-start mini-screen:text-xl uppercase text-balance`} data-aos="fade-up" data-aos-duration="900">
                                    <h2>oro puro careisgold nella tua gioielleria</h2>
                                </div>
                                <div data-aos="fade-zoom-in" data-aos-duration="1000"
                                    className={`text-lg md:text-xl xl:text-2xl mb-5 text-black md:text-white text-center md:text-start mini-screen:text-base text-balance`}>
                                    Trova il negozio più vicino a te e prenota il tuo <strong>appuntamento gratuito</strong> con un esperto incaricato, pronto a rispondere ad ogni tua domanda.
                                </div>

                                <div className='flex md:flex-row flex-col gap-5'>
                                    <button
                                        onClick={() => scrollToSection('#mappa-gioiellerie')}
                                        className={`${width < 768 ? 'border-black text-black progress-button-dark' : 'progress-button-light border-slate-50 text-slate-50'}
                                    px-8 py-2 uppercase border text-center transition duration-300 ease-in-out flex flex-wrap justify-center`}
                                    >
                                        Trova la gioielleria più vicina
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className={`opacity-100 h-lvh hidden sm:block sm:w-1/4 z-0`}>
                            <ScrollParallax lerpEase='0.30' zIndex='0' enableOnTouchDevice={false} strength='0.14'>
                                <img src={oroPuroMani} alt='Oro Puro Mani' className='w-full h-full object-cover' />
                            </ScrollParallax>
                        </div>
                    </div>

                    <img src={oroPuroMani} alt="Oro puro mani" className='block md:hidden w-full h-auto' />
                </div>
            </section>

            {/** sezione con lista */}
            <div className='mx-auto'>
                <div className='flex flex-col sm:flex-row min-h-lvh mini-screen:h-[650px] justify-center items-center bg-white relative z-60'>
                    <div className='w-full hidden md:w-2/5 md:flex justify-center items-center'>
                        <img src={lingotti} alt="Lingotti" className='h-full w-auto' />
                    </div>
                    <div className='w-full md:w-3/5 xl:w-2/5 flex justify-center items-center px-8 py-12 '>
                        <div className='text-center md:text-left w-full sm:max-w-md lg:max-w-lg xl:max-w-xl me-auto'>
                            <h2 className='text-3xl md:text-2xl mini-screen:text-xl font-bold uppercase ' data-aos="fade-up" data-aos-duration="900">
                                La solidità dell’oro fisico da investimento direttamente tra le tue mani
                            </h2>
                            <div data-aos="fade-zoom-in" data-aos-duration="1000" className='mb-4'>
                                <ul className="list-disc list-inside space-y-6 text-black my-10 mini-screen:text-sm text-xl md:text-lg">
                                    <li className="text-left" data-aos="fade-right" data-aos-duration="1000">
                                        <b>PRESENTI IN TUTTA ITALIA:  </b>
                                        grazie a una rete capillare di incaricati all’interno delle gioiellerie, hai sempre un punto di riferimento vicino a te, ovunque ti trovi.
                                    </li>
                                    <li className="text-left" data-aos="fade-right" data-aos-duration="1300">
                                        <b>HUMAN TOUCH: </b>
                                        dialogo diretto e assistenza dedicata un incaricato Careisgold direttamente in gioielleria.
                                    </li>
                                    <li className="text-left" data-aos="fade-right" data-aos-duration="1600">
                                        <b>UNA SCELTA DI VALORE: </b>
                                        l’Oro da investimento è una soluzione responsabile per tutelare il tuo domani e quello di chi ami, ideale per sé stessi o come regalo.
                                    </li>
                                    <li className="text-left" data-aos="fade-right" data-aos-duration="1900">
                                        <b>MASSIMA PUREZZA GARANTITA: </b>
                                        Careisgold commercia solo lingotti certificati “Good Delivery”, in Oro Puro 24k di purezza 999,9‰: il massimo standard di qualità e sicurezza sul mercato.
                                    </li>
                                </ul>


                                <button
                                    onClick={() => scrollToSection('#form-gioiellerie')}
                                    className="w-full lg:w-fit border-black text-black progress-button-dark px-8 py-2 uppercase border text-center 
                                    transition duration-300 ease-in-out"
                                >
                                    Scopri di più
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/** sezione mani e lingotto - sei proprietario gioielleria */}
            <div className='relative z-20 h-lvh overflow-hidden'>
                <ScrollParallax enableOnTouchDevice={true} isAbsolutelyPositioned={true} lerpEase="0.05">
                    <img src={regalo} alt='background' className="absolute top-0 left-0 w-full md:h-full h-[500px] object-cover" />
                </ScrollParallax>
                <div className="absolute top-0 left-0 bg-black bg-opacity-40 w-full h-full flex justify-center items-center">
                    <div className="pt-20 h-full">
                        <div className='w-full h-full mx-auto flex flex-col items-center justify-between'>
                            <h2 className="lg:text-3xl text-2xl text-white font-semibold uppercase" data-aos="fade-up" data-aos-duration="1000">
                                sei proprietario di una gioielleria?
                                <br />
                                entra nel mondo di careisgold
                            </h2>
                            <div className="space-y-4 lg:w-[60%] mx-6">
                                <p className="text-xl text-white" data-aos="fade-up" data-aos-duration="1000">
                                Careisgold si rivolge alle gioiellerie che intendono ampliare la propria offerta con l’Oro puro fisico da investimento.
                                </p>
                                <p className="text-xl text-white" data-aos="fade-up" data-aos-duration="1000">
                                Distinguiti nel mercato, fidelizza la tua clientela e offri ai tuoi clienti l’opportunità di investire nel bene rifugio per eccellenza direttamente all’interno della tua gioielleria.
                                </p>
                                
                                <button
                                    onClick={() => scrollToSection('#form-gioiellerie')}
                                    className="progress-button-light border-slate-50 text-slate-50 px-8 py-2 uppercase border text-center 
                                    transition duration-300 ease-in-out w-full lg:w-fit mx-auto !mt-12"
                                    >
                                    Scopri di più
                                </button>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            {/* <div>
                <div className="space-y-4 lg:w-[60%] mx-auto w-full">
                    <p className="text-xl text-white" data-aos="fade-up" data-aos-duration="1000">
                        Careisgold si rivolge alle gioiellerie che intendono ampliare la propria offerta con l’Oro puro fisico da investimento.
                    </p>
                    <p className="text-xl text-white" data-aos="fade-up" data-aos-duration="1000">
                        Distinguiti nel mercato, fidelizza la tua clientela e offri ai tuoi clienti l’opportunità di investire nel bene rifugio per eccellenza direttamente all’interno della tua gioielleria.
                    </p>

                    <button
                        onClick={() => scrollToSection('#form-gioiellerie')}
                        className="progress-button-light border-slate-50 text-slate-50 px-8 py-2 uppercase border text-center 
                                    transition duration-300 ease-in-out w-full lg:w-fit mx-auto !mt-12"
                    >
                        Scopri di più
                    </button>
                </div>
            </div> */}


            {/*form + mappa */}
            <div className='h-auto flex items-center justify-center lg:mt-10 mb-5 md:mb-56' >
                <div className='w-full px-4 lg:px-0' id='form-gioiellerie'>
                    <div className="flex flex-col lg:flex-row items-start justify-evenly mt-20">
                        <div className='w-full lg:w-3/6'>
                            <Form
                                landingName='oro prestige'
                                getFields={oroPrestigeFormFields}
                                formSchema={schemaOroPrestige}
                                submitMapper={submitMapper}
                            />

                        </div>

                        <div className='w-full lg:w-2/6 py-8 lg:py-16' >
                            <div className='w-full text-start text-slate-50 pb-10'>
                                <p className='text-slate-50 text-4xl font-bold mb-5 uppercase'>Contattaci</p>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item bg-light ms-0 ps-0 flex items-center mb-3">
                                        <FaMapMarkerAlt className="me-5" />
                                        <a className="text-decoration-none text-dark font-medium opacity-75" rel="noreferrer noopener" href="https://goo.gl/maps/y7ADbUdXX1ZZppbK9" target="_blank">
                                            <p className="m-0">Via MONTE BALDO, 14/D INT. 3 37069 VILLAFRANCA DI VERONA (VR)</p>
                                        </a>
                                    </li>
                                    <li className="list-group-item bg-light ms-0 ps-0 flex items-center mb-3">
                                        <FaPhone className="me-5" />
                                        <a className="text-decoration-none text-dark font-medium opacity-75" href="tel:045 2457421" rel="noreferrer noopener">
                                            <p className="m-0">045 2457421</p>
                                        </a>
                                    </li>
                                    <li className="list-group-item bg-light ms-0 ps-0 flex items-center mb-3">
                                        <FaEnvelope className="me-5" />
                                        <a className="text-decoration-none text-dark font-medium opacity-75" href="mailto:info@oroprestige.it" rel="noreferrer noopener">
                                            <p className="m-0">INFO@OROPRESTIGE.IT</p>
                                        </a>
                                    </li>
                                </ul>
                                <p className="text-lg font-semibold mt-4">
                                    Sede legale:
                                </p>
                                <p className="mt-2 pb-4">
                                    Via Monte Baldo 14/D, Villafranca di Verona <br />
                                    C.F./P.Iva 04598560235 - REA VR-433912<br />
                                    CAP. SOCIALE € 2.000.000,00 i.v.<br />
                                    <a className="text-decoration-none text-dark" href="mailto:careisgoldspa@pec.careisgold.it" rel="noreferrer noopener">careisgoldspa@pec.careisgold.it</a><br />
                                    Operatore Professionale Oro - iscritto nel registro OAM n. OPO6
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='w-full bg-slate-50' id='mappa-gioiellerie'>
                        <div ref={ref}>
                            {inView && (
                                <Wrapper apiKey={googleMaps}>
                                    <GoogleMaps gioiellerie={gioiellerie} />
                                </Wrapper>
                            )}
                        </div>
                    </div>
                </div>
            </div>




        </>
    );
}

export default GioiellerieB2C;